module.exports = __webpack_public_path__ + "img/portifolio_drone.190655e9.jpg";